import React, { Component } from 'react';

import bookmark from '../../../../Images/Icons/bookmark.png';
import bookmark_on from '../../../../Images/Icons/bookmark_on.png';
import Power_icon from '../../../../Images/Icons/turn-off.png';
import error from '../../../../Images/Cell_Status_Icon/error.png';
import offtimer from '../../../../Images/Cell_Status_Icon/Offtimer/offtimer-green.png';
import Offtimer_icon from '../../../../Images/Daikin_Images/image/Offtimer.png';
import chmaster from '../../../../Images/Cell_Status_Icon/CHmaster/chmaster.png';
import filter from '../../../../Images/Daikin_Images/image/Filtersign.png';
import room_temp from '../../../../Images/Cell_Status_Icon/Room_Temp/thermo.png';
import humid from '../../../../Images/Daikin_Images/icon/Humid.png';
import batt from '../../../../Images/Daikin_Images/image/Battery.png';

import powerful_mode_icon from '../../../../Images/Daikin_Images/image/Heat.png';
import eco_mode_icon from '../../../../Images/Daikin_Images/image/Cool.png';
import streamer_mode_icon from '../../../../Images/Daikin_Images/image/Dry.png';
import defrost_icon from '../../../../Images/Daikin_Images/image/Cool.png';

// Hrv
import Freshup_on from '../../../../Images/Daikin_Images/image/AutoChangeover.png';
import Freshup_off from '../../../../Images/Daikin_Images/image/Back.png';

import {
	getIcon, getModeIcon, getMode2Icon, getFlapIcon, getFlap2Icon, getFanstepIcon, getBathVentIcon,
	getHumidityIcon, getVModeIcon
} from '../../../Common/Common';
import '../../../Part_Sample/animations.css';

export default class Cell extends Component {
	constructor(props) {
		super(props);
		let bookmark_list = {};
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		if (controller_info.bookmark_list != null) {
			if (controller_info.bookmark_list[this.props.receiver.active_controller.username] != null) {
				bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username]
			}
		}

		if (bookmark_list.devices == null || bookmark_list.devices == undefined) {
			bookmark_list.devices = [];
		}

		let is_bookmark = false;

		if (bookmark_list.devices.length > 0 && bookmark_list.devices.includes(this.props.point_id)) {
			is_bookmark = true;
		}

		this.state = {
			is_cell_focused: false,
			is_show_operation: false,
			is_bookmark: is_bookmark,
		}
	}

	handleOperation = () => {
		let managementPointInfo = this.props.point_info;
		if (this.props.point_info.comm_stat) { //if there are no communication errors
			let operationCapability = managementPointInfo.op_cap; //if this device has operation capability
			if (operationCapability) {
				if (['Ac', 'Dehumi', 'Ahu', 'Status', 'Switch', 'Level', 'LevelSw', 'Shutter', 'Lock', 'Rgbw', 'Hrv'].includes(this.props.point_info.type)) {
					document.getElementById(this.props.id + '_cell_external').classList.remove('flipInY');
					document.getElementById(this.props.id + '_cell_external').classList.add('fadeIn');
					setTimeout(() => {
						if (document.getElementById(this.props.id + '_cell_external') != null) {
							document.getElementById(this.props.id + '_cell_external').classList.remove('fadeIn');
						}
						// Check that this management point can open operation screen
						let param = this.props.param;
						param.point_id = this.props.point_id;
						param.point_info = this.props.point_info;
						param.group_info = this.props.group_info;
						param.groups = this.props.groups;
						param.scenes = this.props.scenes;
						// group_id should already be inside param
						param.group_detail_from = this.props.param.from;
						param.from = this.props.from;
						param.mp_scroll_top = this.props.scroll_top; //Retain scroll position of groups screen
						param.deviceErrorMessage = this.state.errorCode;

						this.props.content_handler('Operation_Screen', param);
					}, 300);
				}
			}
		}
	}

	handleToggleBookmark = (e) => {
		e.stopPropagation();
		let is_bookmark = !this.state.is_bookmark;
		this.setState({ is_bookmark: is_bookmark });

		let bookmark_list = {};
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		if (controller_info.bookmark_list == null) {
			controller_info.bookmark_list = {};
			controller_info.bookmark_list[this.props.receiver.active_controller.username] = {};
		} else if (controller_info.bookmark_list[this.props.receiver.active_controller.username] != null) {
			bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username];
		}

		if (bookmark_list.devices == null || bookmark_list.devices == undefined) {
			bookmark_list.devices = [];
		}

		if (is_bookmark && !bookmark_list.devices.includes(this.props.point_id)) {
			bookmark_list.devices.push(this.props.point_id);
		} else if (!is_bookmark && bookmark_list.devices.includes(this.props.point_id)) {
			bookmark_list.devices.splice(bookmark_list.devices.indexOf(this.props.point_id), 1);
		}

		controller_info.bookmark_list[this.props.receiver.active_controller.username] = bookmark_list;
		window.localStorage.setItem(this.props.receiver.active_controller.name, JSON.stringify(controller_info));
	}

	handlePromptErrorMessage = (e, error_code, type) => {
		e.stopPropagation();
		//  If error doesnt exist, Add Alert elem if alert exists
		window.app.showToast(this.props.receiver.getString(type) + ': ' + this.props.receiver.getString(error_code), 3000);
	}

	render() {
		let cell_width = 135;

		let style = {
			display: 'inline-block',
			verticalAlign: 'top',
			position: 'relative'
		}

		let status_gradient = 'unset';
		if (this.props.point_info.stat == 'on') status_gradient = 'radial-gradient(circle, rgb(126 255 107) 0%, rgba(255,255,255,1) 100%)'

		//If lock is open - display gradient
		if (this.props.point_info.lock != null) {
			if (this.props.point_info.lock == 'open') {
				status_gradient = 'radial-gradient(circle, rgb(126 255 107) 0%, rgba(255,255,255,1) 100%)'
			}
		}

		let cell_style = {
			cursor: 'pointer',
			width: cell_width,
			height: cell_width,
			margin: 5,
			padding: 5,
			backgroundColor: this.props.point_info.comm_stat ? 'white' : '#b2b2b2ad',
			opacity: this.props.point_info.comm_stat ? 1 : 0.5,
			borderRadius: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			zIndex: 1,
			backgroundImage: this.props.point_info.comm_stat ? status_gradient : null
		}
		// use the getIcon function to retrieve the icon image.
		let icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);

		let bg = {
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
			opacity: .15,
			backgroundImage: "url(" + icon + ")",
			backgroundRepeat: 'no-repeat',
			backgroundSize: (cell_width) + 'px ' + (cell_width) + 'px',
			marginLeft: 5,
			marginTop: 5,
			zIndex: -1
		}

		// jsx elements for display
		let mode_elem = null;
		let mode2_elem = null;
		let fanstep_elem = null;
		let flap_elem = null;
		let flap2_elem = null;
		let rt_elem = null;			// Room temperature
		let sp_elem = null;			// Setpoint
		let batt_elem = null;
		let av_elem = null;			// analog value
		let selected_scene_elem = null; // MultiStat and Selection can set scene
		let ch_master_elem = null;	// Master Indoor unit
		let filter_elem = null;
		let offtimer_elem = null;
		let pwfl_elem = null; 		// Powerful mode
		let eco_elem = null; 		// Eco mode
		let stream_elem = null; 	// Streamer mode
		let bvent_elem = null; 		// Bath Ventilation
		let hum_elem = null; 		// Humidity Control
		let foff_elem = null;		// Force Off	
		let fthoff_elem = null; 	// Force Off Thermostat
		let defrost_elem = null;
		let meter_elem = null;
		let device_error_elem = null;  //Device Error Message

		// Hrv
		let vmode_elem = null;
		let vamount_elem = null;
		let freshup_elem = null;

		// Hotel Guest Room
		let hotel_room_elem = null;

		// Alert elem for Value if beyond min/max
		let alert_elem = null;

		let status_img_width = 15;

		if (this.props.point_info.comm_stat) {
			// AC only displays
			if (this.props.point_info.type == 'Ac') {
				// sp_elem
				let sp = this.props.point_info.actual_mode == 'C' ? this.props.point_info.csp : this.props.point_info.hsp;
				if (sp != null && sp != undefined) {
					sp_elem = <div style={{ textAlign: ' center', width: cell_width }}>
						<span style={{ 
							fontSize: 24, 
							color: this.props.point_info.actual_mode == 'C' ? 'blue' : 'red',
							textDecoration: this.props.point_info.sb_stat == 'on' ?  'underline' : 'initial'
						}}>
							{sp + this.props.receiver.getString('DEG')}
						</span>
					</div>

					if (this.props.point_info.mode == 'F' || this.props.point_info.mode == 'D') {
						sp_elem = <div style={{ height: 24, textAlign: ' center', width: cell_width }}></div>
					}
				}

				// mode_elem
				mode_elem = <div style={{ display: 'inline-block' }}>
					<img src={getModeIcon(this.props.point_info.mode)} style={{ width: status_img_width }} />
				</div>

				// mode2_elem
				if (this.props.point_info.mode2_cap.RD || this.props.point_info.mode2_cap.AD
					|| this.props.point_info.mode2_cap.GS || this.props.point_info.mode2_cap.BD
					|| this.props.point_info.mode2_cap.PH) {
					mode2_elem = <div style={{ display: 'inline-block' }}>
						<img src={getMode2Icon(this.props.point_info.mode2)} style={{ width: status_img_width }} />
					</div>
				}

				// fanstep_elem
				if (this.props.point_info.fanstep_cap != null) {
					fanstep_elem = <div style={{ display: this.props.point_info.fanstep_cap.S != 0 ? 'inline-block' : 'none' }}>
						<img src={getFanstepIcon(this.props.point_info.fanstep_cap.S != null ? this.props.point_info.fanstep_cap.S : 3, this.props.point_info.fanstep)} style={{ width: status_img_width }} />
					</div>
				}

				// flap_elem
				if (this.props.point_info.flap_cap != null) {
					flap_elem = <div style={{ display: this.props.point_info.flap_cap.D != 0 ? 'inline-block' : 'none' }}>
						<img src={getFlapIcon(this.props.point_info.flap_cap.D != null ? this.props.point_info.flap_cap.D : 3, this.props.point_info.flap)} style={{ width: status_img_width }} />
					</div>
				}

				// flap2_elem
				if (this.props.point_info.flap2_cap != null) {
					flap2_elem = <div style={{ display: this.props.point_info.flap2_cap.D != 0 ? 'inline-block' : 'none' }}>
						<img src={getFlap2Icon(this.props.point_info.flap2_cap.D != null ? this.props.point_info.flap2_cap.D : 3, this.props.point_info.flap2)} style={{ width: status_img_width }} />
					</div>
				}

				// filter_elem
				if (this.props.point_info.filter == 'on') {
					filter_elem = <div style={{ display: 'inline-block' }}>
						<img src={filter} style={{ width: status_img_width }} />
					</div>
				}

				// ch_master_elem
				if (this.props.point_info.ch_master) {
					ch_master_elem = <div id='ch_master' style={{ display: 'inline-block' }}>
						<img src={chmaster} style={{ width: status_img_width }} />
					</div>
				}

				// pwfl_elem
				if (this.props.point_info.pwfl == 'on') {
					pwfl_elem = <div style={{ display: 'inline-block' }}>
						<img src={powerful_mode_icon} style={{ width: status_img_width }} />
					</div>
				}

				// eco_elem
				if (this.props.point_info.eco == 'on') {
					eco_elem = <div style={{ display: 'inline-block' }}>
						<img src={eco_mode_icon} style={{ width: status_img_width }} />
					</div>
				}

				// stream_elem
				if (this.props.point_info.stream == 'on') {
					stream_elem = <div style={{ display: 'inline-block' }}>
						<img src={streamer_mode_icon} style={{ width: status_img_width }} />
					</div>
				}

				// bvent_elem
				if (this.props.point_info.bvent_cap) {
					bvent_elem = <div style={{ display: 'inline-block' }}>
						<img src={getBathVentIcon(this.props.point_info.bvent)} style={{ width: status_img_width }} />
					</div>
				}

				// hum_elem
				if (this.props.point_info.hum_cap) {
					hum_elem = <div style={{ display: 'inline-block' }}>
						<img src={getHumidityIcon(this.props.point_info.hum)} style={{ width: status_img_width }} />
					</div>
				}

				// foff_elem
				if (this.props.point_info.foff == 'on') {
					foff_elem = <div style={{ display: 'inline-block' }}>
						<span className='danger'>{this.props.receiver.getString('force_off')}</span>
					</div>
				}

				// fthoff_elem
				if (this.props.point_info.fthoff == 'on') {
					fthoff_elem = <div style={{ display: 'inline-block' }}>
						<span className='danger'>{this.props.receiver.getString('force_off_thermo_status')}</span>
					</div>
				}

				// defrost_elem
				if (this.props.point_info.defrost == 'on') {
					defrost_elem = <div style={{ display: 'inline-block' }}>
						<img src={defrost_icon} style={{ width: status_img_width }} />
					</div>
				}
			}

			if (this.props.point_info.type == 'Dehumi') {
				// fanstep_elem
				if (this.props.point_info.fanstep_cap != null) {
					fanstep_elem = <div style={{ display: this.props.point_info.fanstep_cap.S != 0 ? 'inline-block' : 'none' }}>
						<img src={getFanstepIcon(this.props.point_info.fanstep_cap.S != null ? this.props.point_info.fanstep_cap.S : 3, this.props.point_info.fanstep)} style={{ width: status_img_width }} />
					</div>
				}

				if(this.props.point_info.hasOwnProperty('hum_sp')) {
					let hum_sp = this.props.point_info.hum_sp;
					sp_elem = <div style={{ textAlign: ' center', width: cell_width }}>
						<span style={{ 
							fontSize: 24, 
							color: 'blue',
							textDecoration: 'initial'
						}}>
							{hum_sp + this.props.point_info.unit}
						</span>
					</div>
				}

				if (this.props.point_info.hasOwnProperty('av')) {
					rt_elem = <div id='humidity' style={{ position: 'relative' }}  >
						<div style={{ position: 'absolute', top: -85, left: 85 }} onClick={this.handleOperation}>
							<img src={humid} style={{ width: 19, display: 'inline-block' }} />
							<span>{this.props.point_info.av + this.props.point_info.unit}</span>
						</div>
					</div>
				}
			}

			// rt_elem
			if (this.props.point_info.temp != null && this.props.point_info.temp != undefined) {
				rt_elem = <div id='room_temp' style={{ position: 'relative' }}  >
					<div style={{ position: 'absolute', top: -85, left: 85 }} onClick={this.handleOperation}>
						<img src={room_temp} style={{ width: 10, display: 'inline-block' }} />
						<span>{this.props.point_info.temp + this.props.receiver.getString("DEG")}</span>
					</div>
				</div>
			}

			// batt_elem
			if (this.props.point_info.bat != null) {
				batt_elem = <div style={{ display: 'inline-block' }}>
					<img src={batt} style={{ width: 15 }} />
					<span style={{}}>{this.props.point_info.bat + '%'}</span>
				</div>
			}

			// av_elem
			if (this.props.point_info.av != null && this.props.point_info.type != 'Dehumi') {
				let unit = this.props.point_info.unit;
				if (unit == 'DEG') unit = this.props.receiver.getString('DEG');

				av_elem = <div style={{ display: 'inline-block', maxWidth: '80px', overflow: 'hidden' }}>
					<span style={{}}>{this.props.point_info.av + unit}</span>
				</div>
			}

			// selected_scene_elem
			if (this.props.point_info.mstat != null) {
				if (this.props.point_info.type == 'Selection') {
					if (this.props.point_info.selection != null) {
						selected_scene_elem = <div style={{ display: 'inline-block' }}>
							<span style={{}}>{this.props.point_info.selection[this.props.point_info.mstat]}</span>
						</div>
					}
				} else {
					selected_scene_elem =
						<div style={{ display: 'inline-block' }}>
							<span style={{}}>{this.props.point_info.mstat}</span>
						</div>
				}
			}

			// offtimer_elem
			if (this.props.point_info.off_timer == 'on') {
				offtimer_elem = <div style={{ display: 'inline-block' }}>
					<img src={Offtimer_icon} style={{ width: status_img_width }} />
				</div>
			}

			// meter_elem
			if (this.props.point_info.meter != null) {
				if (this.props.point_info.type == 'SMeter') {
					meter_elem = <div style={{ overflow: 'hidden' }}>
						<div>
							<span className='normal' style={{ fontSize: 14 }}>{this.props.point_info.meter + ' ' + this.props.point_info.unit}</span>
						</div>
						<div>
							<span className='normal' style={{ fontSize: 12 }}>{this.props.point_info.value + ' ' + this.props.point_info.sub_unit}</span>
						</div>
					</div>
				} else {
					meter_elem = <div style={{ display: 'inline-block', overflow: 'hidden' }}>
						<span className='normal' style={{ fontSize: 14 }}>{this.props.point_info.meter + ' ' + this.props.point_info.unit}</span>
					</div>
				}
			}

			// Hrv
			if (this.props.point_info.vmode != null) {
				vmode_elem = <div style={{ display: 'inline-block' }}>
					<img src={getVModeIcon(this.props.point_info.vmode)} style={{ width: status_img_width }} />
				</div>
			}

			if (this.props.point_info.vamount != null) {
				vamount_elem = <div style={{ display: 'inline-block' }}>
					<img src={getFanstepIcon(2, this.props.point_info.vamount)} style={{ width: status_img_width }} />
				</div>
			}

			if (this.props.point_info.freshup != null) {
				freshup_elem = <div style={{ display: 'inline-block' }}>
					<img src={this.props.point_info.freshup == 'on' ? Freshup_on : Freshup_off} style={{ width: status_img_width }} />
				</div>
			}

			// device error message 
			if (this.props.point_info.hasOwnProperty('error')) { //check if device has device error
				let device_error = this.props.point_info.error;
				for (var key in device_error) {
					if (device_error[key]) {
						// If error doesnt exist, Add Alert elem if alert exists
						device_error_elem = <div style={{ position: 'absolute', bottom: 0, width: 25, marginBottom: 3 }}>
							<img src={error} style={{ cursor: 'pointer', width: 25 }} onClick={(event) => { this.handlePromptErrorMessage(event, key, 'error') }} />
						</div>
						break;
					}
				}
			}

			// If error doesnt exist, Add Alert elem if alert exists
			if (this.props.point_info.alert != null && device_error_elem == null) {
				let alert = this.props.point_info.alert;
				for (let key in alert) {
					if (alert[key]) {
						alert_elem = <div style={{ position: 'absolute', bottom: 0, width: 25, marginBottom: 3 }}>
							<img src={error} style={{ cursor: 'pointer', width: 25 }} onClick={(event) => { this.handlePromptErrorMessage(event, key, 'alert') }} />
						</div>
						break;
					}
				}
			}
		}

		return (
			<div style={style} id={this.props.id + '_cell_external'}>
				<div id={this.props.id + '_cell_internal'} style={cell_style} onClick={this.handleOperation} className='flipInY'>
					<div style={bg}></div>
					<div style={{ display: 'inline-block', width: 25 }}>
						<img src={this.state.is_bookmark ? bookmark_on : bookmark} style={{ cursor: 'pointer', width: 25, }} onClick={this.handleToggleBookmark} />
					</div>

					<div style={{ display: 'inline-block', width: cell_width - 30, verticalAlign: 'top', textAlign: 'left' }}>
						<span id={this.props.id + '_cell_span'} style={{ marginLeft: 5, fontSize: 12, display: '-webkit-box', overflow: 'hidden', textOverflow: 'ellipsis', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{this.props.point_info.name}</span>
					</div>

					{device_error_elem}
					{alert_elem}

					<div style={{ display: 'inline-block', marginTop: 5, visibility: this.props.point_info.comm_stat ? 'visible' : 'hidden' }}>
						{sp_elem}
					</div>

					<div id='status'
						style={{
							width: '100%', textAlign: 'center', display: 'inline-block',
							verticalAlign: 'top', marginTop: 25, visibility: this.props.point_info.comm_stat ? 'visible' : 'hidden'
						}}>
						{ch_master_elem}
						{offtimer_elem}
						{filter_elem}
						{mode_elem}
						{av_elem}
						{fanstep_elem}
						{flap_elem}
						{flap2_elem}
						{selected_scene_elem}
						{pwfl_elem}
						{eco_elem}
						{stream_elem}
						{foff_elem}
						{meter_elem}
					</div>
					<div style={{ marginTop: 30, textAlign: 'right' }}>
						{batt_elem}
					</div>
					<div style={{ marginTop: 30 }}>
						{vmode_elem}
						{vamount_elem}
						{freshup_elem}
					</div>
				</div>
				{rt_elem}
			</div>

		)
	}
}
